import request from '@/axios';

// 查列表-线上
export const goodsPageApi = query => {
    return request({
        url: '/lebo-member/web/member/goods/page',
        method: 'GET',
        params: query
    });
};

// 查列表-本地
export const goodsLocalPageApi = query => {
    return request({
        url: '/lebo-member/web/member/goods-local/page',
        method: 'GET',
        params: query
    });
};

// 详情
export const goodsLocalDetailApi = query => {
    return request({
        url: '/lebo-member/web/member/goods-local/detail',
        method: 'GET',
        params: query
    });
};


// 新增
export const goodsLocalSaveApi = query => {
    return request({
        url: '/lebo-member/web/member/goods-local/save',
        method: 'POST',
        data: query
    });
};

// 修改
export const goodsLocalUpdateApi = query => {
    return request({
        url: '/lebo-member/web/member/goods-local/update',
        method: 'POST',
        data: query
    });
};


// 审核通过
export const goodsLocalPassApi = query => {
    return request({
        url: '/lebo-member/web/member/goods-local/batch-pass',
        method: 'POST',
        params: query
    });
};

// 撤销审核
export const goodsLocalRecallApi = query => {
    return request({
        url: '/lebo-member/web/member/goods-local/batch-recall?ids=' + query.ids,
        method: 'POST',
        data: query
    });
};

// 审核拒绝
export const goodsLocalRejectApi = query => {
    return request({
        url: '/lebo-member/web/member/goods-local/batch-reject',
        method: 'POST',
        params: query
    });
};

// 删除
export const goodsLocalremoveApi = query => {
    return request({
        url: '/lebo-member/web/member/goods-local/batch-remove?ids=' + query.ids,
        method: 'POST',
        data: query
    });
};

// 审核快照
export const goodsLocalSnapshotApi = query => {
    return request({
        url: '/lebo-member/web/member/goods-local/snapshot',
        method: 'GET',
        params: query
    });
};

// 提交审核
export const goodsLocalSubmitApi = query => {
    return request({
        url: '/lebo-member/web/member/goods-local/batch-submit?ids=' + query.ids,
        method: 'POST',
        params: query
    });
};

// 可见人群-下载手机号名单模板，复用支付页配置既有的模板端点，与商品侧共用同一份 PhoneExcel 模板
export const visiblePhoneTemplateApi = () => {
    return request({
        url: '/lebo-member/web/member/config/exportPhone-template',
        method: 'GET',
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/octet-stream'
        }
    });
};

// 可见人群-导入手机号名单
export const visiblePhoneImportApi = query => {
    return request({
        url: '/lebo-member/web/member/goods-local/visible-phone/import',
        method: 'POST',
        data: query,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

// 可见人群-导出已导入的手机号名单
export const visiblePhoneExportApi = query => {
    return request({
        url: '/lebo-member/web/member/goods-local/visible-phone/export',
        method: 'GET',
        params: query,
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/octet-stream'
        }
    });
};


// log日志
export const operateLogPageApi = query => {
    return request({
        url: '/lebo-member/web/member/operate-log/page',
        method: 'GET',
        params: query
    });
};

// 字典
export const getDictionaryApi = (query) => {
    return request({
      url: '/lebo-system/dict-biz/dictionary',
      method: 'get',
      params: query,
    })
  }

// 会员类型字典
export const memberTypeDictApi = (query) => {
    return request({
      url: '/lebo-member/web/member/type/dict',
      method: 'get',
      params: query,
    })
  }

// 根据会员查询端类型列表
export const memberTypeClientsApi = (query) => {
    return request({
      url: '/lebo-member/web/member/type/clients',
      method: 'get',
      params: query,
    })
  }

// 查询所有端类型列表
export const memberTypeClientsAllApi = () => {
    return request({
      url: '/lebo-member/web/member/type/clientsAll',
      method: 'get',
    })
  }
